import { ApiResult, request, safeRequest } from '@synergy/api';

import { SingleInquiryRequest } from './models/single-inquiry-request';

export class SingleInquiryApi {
    constructor(protected baseUrl: string) {}

    public sendSingleInquiry = (
        singleInquiryRequest: SingleInquiryRequest
    ): Promise<ApiResult<{ shoppingCartTotal: number }>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/create-single-inquiry`, singleInquiryRequest),
            response => response.data
        );
    };
}
